var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinN1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88602 9.59796C7.32601 9.59796 9.30402 7.61996 9.30402 5.17996C9.30402 2.73997 7.32601 0.761963 4.88602 0.761963C2.44602 0.761963 0.468018 2.73997 0.468018 5.17996C0.468018 7.61996 2.44602 9.59796 4.88602 9.59796Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6611 12.543H3.1101C2.05745 12.543 1.2041 13.3963 1.2041 14.449V32.727C1.2041 33.7796 2.05745 34.633 3.1101 34.633H6.6611C7.71376 34.633 8.5671 33.7796 8.5671 32.727V14.449C8.5671 13.3963 7.71376 12.543 6.6611 12.543Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.603 20.642V33.159C33.6019 33.549 33.4467 33.9227 33.1711 34.1986C32.8955 34.4746 32.5219 34.6304 32.132 34.632H27.713C27.3226 34.6309 26.9486 34.4754 26.6725 34.1994C26.3965 33.9234 26.241 33.5493 26.24 33.159V22.85C26.2241 21.8841 25.8292 20.9631 25.1405 20.2857C24.4518 19.6083 23.5245 19.2287 22.5585 19.2287C21.5925 19.2287 20.6651 19.6083 19.9764 20.2857C19.2878 20.9631 18.8929 21.8841 18.877 22.85V33.159C18.8759 33.5493 18.7203 33.9234 18.4443 34.1994C18.1683 34.4754 17.7943 34.6309 17.4039 34.632H12.986C12.5956 34.6309 12.2216 34.4754 11.9456 34.1994C11.6695 33.9234 11.514 33.5493 11.5129 33.159V14.016C11.5145 13.626 11.6703 13.2524 11.9463 12.9768C12.2222 12.7013 12.596 12.546 12.986 12.545H17.405C17.795 12.546 18.1687 12.7013 18.4446 12.9768C18.7206 13.2524 18.8764 13.626 18.878 14.016V14.958C19.6706 13.9638 20.6794 13.1631 21.8276 12.617C22.9759 12.0708 24.2335 11.7934 25.5049 11.8059C29.5679 11.8059 33.603 14.751 33.603 20.642Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinN1);
export default __webpack_public_path__ + "static/media/linkedin-n-1.ed5d27624cbf3747e30762e3f2a32147.svg";
export { ForwardRef as ReactComponent };